export const IS_MIZRAHI_BANK_MODAL_SHOWN = 'IS_MIZRAHI_BANK_MODAL_SHOWN';
export const IS_LIKED_TOAST_SHOWN = 'IS_LIKED_TOAST_SHOWN';
export const PAYMENT_PROCESS_ID = 'PAYMENT_PROCESS_ID';
